const brandsMatch = (left: string, right: string): boolean => left.toLowerCase() === right.toLowerCase();

export const isDuplicateBrand = (brand: string, selectedBrands: string[], excludedBrands: string[] = []): boolean =>
    [...selectedBrands, ...excludedBrands].some((item) => brandsMatch(item, brand));

export const resolveBrandsOnApply = (
    pendingBrands: string[],
    searchValue: string,
    excludedBrands: string[] = [],
): string[] => {
    if (pendingBrands.length > 0) {
        return pendingBrands;
    }

    const trimmedSearch = searchValue.trim();
    if (!trimmedSearch || isDuplicateBrand(trimmedSearch, [], excludedBrands)) {
        return [];
    }

    return [trimmedSearch];
};
